import APIService from "api/APIService";
import ApiStorage from "./ApiStorage";

const ApiAppService = APIService;

ApiAppService.setApiStorage(ApiStorage);

export default ApiAppService;
